import { Component, OnInit, Input } from '@angular/core';
import { MainService } from '../../_services/main.service';
import { AuthService } from '../../_services/auth.service';
import { ShopService } from '../../_services/shop.service';
import { CartService } from '../../_services/cart.service';
import { ContextMain } from '../../_models/common/context.main';

@Component({
  selector: 'app-header-twimva',
  templateUrl: './header-twimva.component.html',
  styleUrls: ['./header-twimva.component.scss']
})
export class HeaderTwimvaComponent implements OnInit {
  @Input() ctx: ContextMain;

  constructor(
    public mainService: MainService,
    public authService: AuthService,
    public shopService: ShopService,
    public cartService: CartService
  ) { }


  ngOnInit() {
  }

}
